import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import {
    AccountQuotaConfigRequest,
    AccountQuotaResponse,
    AccountQuotaUsageQuery,
    AccountQuotaUsageResponse,
    SetAccountQuotaAdditionalRequest
} from './models/curation-agent.api';

/**
 * Admin surface for an account's AI agent quota pool - agents-service
 * `api/v1/agents/accounts/:accountId/quota`. The account is a route param rather than the caller's
 * own, so these need the users-admin role.
 */
@Injectable()
export class AIAgentQuotaAdminApiService {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    static quotaSlug(accountId: number): string {
        return `/agents/accounts/${accountId}/quota`;
    }

    /** 404s when the account has never been provisioned a pool */
    get(accountId: number): Observable<AccountQuotaResponse> {
        return this.neptuneApi.api<AccountQuotaResponse>(
            AIAgentQuotaAdminApiService.quotaSlug(accountId),
            null,
            HttpVerbsEnum.GET
        );
    }

    /** Provisions the pool on first save, updates it after. Never resets an existing pool's count */
    upsert(accountId: number, request: AccountQuotaConfigRequest): Observable<AccountQuotaResponse> {
        return this.neptuneApi.api<AccountQuotaResponse>(
            AIAgentQuotaAdminApiService.quotaSlug(accountId),
            request,
            HttpVerbsEnum.PUT
        );
    }

    /** An absolute set for the current billing period, not an increment */
    setAdditionalQuota(accountId: number, request: SetAccountQuotaAdditionalRequest): Observable<AccountQuotaResponse> {
        return this.neptuneApi.api<AccountQuotaResponse>(
            `${AIAgentQuotaAdminApiService.quotaSlug(accountId)}/additional`,
            request,
            HttpVerbsEnum.PATCH
        );
    }

    getUsage(accountId: number, query: AccountQuotaUsageQuery = {}): Observable<AccountQuotaUsageResponse> {
        return this.neptuneApi.api<AccountQuotaUsageResponse>(
            `${AIAgentQuotaAdminApiService.quotaSlug(accountId)}/usage`,
            null,
            HttpVerbsEnum.GET,
            query
        );
    }
}
